export default __webpack_public_path__ + "static/media/fsync4.40877cb5.png";